import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { patientAPI } from '../../utils/api';

const CITIES = {
    Pakistan: [
        // Punjab
        'Lahore','Faisalabad','Rawalpindi','Islamabad','Gujranwala','Multan','Bahawalpur',
        'Sargodha','Sialkot','Sheikhupura','Jhang','Rahim Yar Khan','Gujrat','Sahiwal',
        'Wah Cantonment','Okara','Chiniot','Kasur','Kamoke','Hafizabad','Khanewal',
        'Khushab','Pakpattan','Mandi Bahauddin','Jhelum','Attock','Chakwal',
        'Toba Tek Singh','Vehari','Layyah','Bhakkar','Muzaffargarh','Lodhran',
        'Bahawalnagar','Narowal','Nankana Sahib','Mianwali','Dera Ghazi Khan',
        'Rajanpur','Hafizabad','Burewala','Jaranwala','Daska','Wazirabad',
        // Sindh
        'Karachi','Hyderabad','Sukkur','Larkana','Nawabshah','Mirpur Khas',
        'Jacobabad','Shikarpur','Khairpur','Dadu','Badin','Sanghar','Mithi',
        'Umerkot','Thatta','Matiari','Jamshoro','Tando Adam','Tando Allahyar',
        'Tando Muhammad Khan','Ghotki','Kashmore','Kamber','Shahdadkot','Kotri',
        'Qambar','Kandhkot','Mehrabpur','Daharki',
        // KPK
        'Peshawar','Mardan','Mingora','Kohat','Abbottabad','Mansehra',
        'Dera Ismail Khan','Bannu','Nowshera','Charsadda','Swabi','Haripur',
        'Karak','Hangu','Lakki Marwat','Tank','Chitral','Dir','Malakand',
        'Buner','Timergara','Parachinar','Oghi','Batkhela',
        // Balochistan
        'Quetta','Turbat','Khuzdar','Hub','Chaman','Gwadar','Zhob','Loralai',
        'Kharan','Panjgur','Awaran','Kalat','Mastung','Pishin','Nushki',
        'Killa Abdullah','Killa Saifullah','Sibi','Dera Bugti','Nasirabad',
        'Jaffarabad','Sohbatpur','Usta Mohammad','Bela','Lasbela',
        // AJK
        'Muzaffarabad','Mirpur (AJK)','Rawalakot','Kotli','Bagh','Haveli',
        // Gilgit-Baltistan
        'Gilgit','Skardu','Hunza','Chilas','Astore','Ghanche',
    ].sort(),
    Iran: [
        'Tehran','Mashhad','Isfahan','Karaj','Tabriz','Shiraz','Ahvaz',
        'Qom','Kermanshah','Zahedan','Rasht','Kerman','Orumiyeh','Zabol',
        'Yazd','Arak','Hamadan','Bandar Abbas','Ardabil','Sanandaj',
    ],
    Afghanistan: [
        'Kabul','Kandahar','Herat','Mazar-i-Sharif','Jalalabad','Kunduz',
        'Lashkar Gah','Taloqan','Khost','Ghazni','Farah','Pul-e-Khumri',
        'Zaranj','Asadabad','Mehtarlam','Charikar','Mahmud-e-Raqi',
    ],
    China: [
        'Beijing','Shanghai','Guangzhou','Shenzhen','Chengdu','Chongqing',
        'Wuhan','Xi\'an','Nanjing','Hangzhou','Tianjin','Urumqi','Kashgar',
        'Kunming','Zhengzhou','Qingdao','Dalian','Shenyang','Harbin',
    ],
    UAE: [
        'Dubai','Abu Dhabi','Sharjah','Ajman','Ras Al Khaimah',
        'Fujairah','Umm Al Quwain','Al Ain','Khor Fakkan','Kalba',
    ],
    'Saudi Arabia': [
        'Riyadh','Jeddah','Mecca','Medina','Dammam','Khobar','Dhahran',
        'Tabuk','Abha','Taif','Jubail','Yanbu','Hail','Najran','Jizan',
        'Al Qatif','Buraidah','Unaizah','Khamis Mushait',
    ],
    Qatar: [
        'Doha','Al Wakrah','Al Khor','Mesaieed','Al Rayyan',
        'Al Shamal','Al Daayen','Umm Salal','Al Shahaniya',
    ],
    Kuwait: [
        'Kuwait City','Hawalli','Salmiya','Farwaniya','Ahmadi',
        'Jahra','Mangaf','Fahaheel','Rumaithiya','Salwa',
    ],
    Bahrain: [
        'Manama','Riffa','Muharraq','Hamad Town','Isa Town',
        'Sitra','Jidhafs','A\'ali','Sanabis','Budaiya',
    ],
    Oman: [
        'Muscat','Salalah','Sohar','Nizwa','Sur','Buraimi',
        'Ibri','Rustaq','Khasab','Haima','Duqm','Al Buraymi',
    ],
    Other: [],
};

const COUNTRIES = Object.keys(CITIES);

const NATIONALITIES = [
    'Pakistani','Iranian','Afghan','Chinese','Emirati','Saudi','Qatari',
    'Kuwaiti','Bahraini','Omani','Other',
];

const OCCUPATIONS = [
    'Govt Employee', 'Private Employee', 'Unemployed', 'Student',
    'Business', 'Retired', 'Farmer', 'Housewife', 'Other',
];

const RELATIONS = ['S/O', 'D/O', 'W/O', 'B/O', 'F/O', 'M/O'];

const initialForm = {
    full_name: '', name_relation: 'S/O', father_name: '', gender: '', date_of_birth: '',
    age_years: '', age_months: '', cnic: '', phone: '', phone_alt: '',
    address: '', city: '', country: 'Pakistan', blood_group: '', religion: '',
    nationality: 'Pakistani', marital_status: '', occupation: '',
    emergency_contact_name: '', emergency_contact_phone: '', emergency_contact_cnic: '',
    emergency_contact_relation: '', allergies: '', chronic_conditions: '', remarks: ''
};

const inputStyle = { width: '100%', padding: '9px 12px', border: '1px solid #d1d5db', borderRadius: 7, fontSize: 13 };
const selectStyle = { ...inputStyle, background: 'white' };

const Field = ({ label, children, required }) => (
    <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 5 }}>
            {label} {required && <span style={{ color: '#dc2626' }}>*</span>}
        </label>
        {children}
    </div>
);

export default function PatientRegistration() {
    const [form, setForm] = useState(initialForm);
    const [loading, setLoading] = useState(false);
    const [registered, setRegistered] = useState(null);

    const set = (key, val) => setForm((f) => ({ ...f, [key]: val }));

    const fmtPhone = (v) => { const d=v.replace(/\D/g,'').slice(0,11); if(d.length<=4) return d; return d.slice(0,4)+'-'+d.slice(4); };
    const fmtCNIC  = (v) => { const d=v.replace(/\D/g,'').slice(0,13); if(d.length<=5) return d; if(d.length<=12) return d.slice(0,5)+'-'+d.slice(5); return d.slice(0,5)+'-'+d.slice(5,12)+'-'+d.slice(12); };

    const handleCountry = (country) => {
        setForm(f => ({ ...f, country, city: '' }));
    };

    const handleDOB = (dob) => {
        if (!dob) { setForm(f => ({ ...f, date_of_birth: '', age_years: '', age_months: '' })); return; }
        const birth = new Date(dob);
        const today = new Date();
        let years = today.getFullYear() - birth.getFullYear();
        let months = today.getMonth() - birth.getMonth();
        if (today.getDate() < birth.getDate()) months--;
        if (months < 0) { years--; months += 12; }
        setForm(f => ({ ...f, date_of_birth: dob, age_years: years >= 0 ? years : 0, age_months: months >= 0 ? months : 0 }));
    };

    const handleAgeYears = (val) => {
        const years = parseInt(val);
        if (!val || isNaN(years)) { setForm(f => ({ ...f, age_years: '', age_months: '', date_of_birth: '' })); return; }
        const estimatedYear = new Date().getFullYear() - years;
        const estimatedDOB = `${estimatedYear}-01-01`;
        setForm(f => ({ ...f, age_years: val, age_months: '0', date_of_birth: estimatedDOB }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await patientAPI.register(form);
            setRegistered(res.data.patient);
            toast.success(`Patient registered! MRN: ${res.data.patient.mrn}`);
            setForm(initialForm);
        } catch (err) {
            if (err.response?.status === 409) {
                toast.warning(`Already registered — MRN: ${err.response.data.existing_mrn}`);
            } else {
                toast.error(err.response?.data?.error || err.response?.data?.message || (err.message === 'Network Error' ? 'Backend server not running' : 'Registration failed'));
            }
        } finally {
            setLoading(false);
        }
    };

    const citiesForCountry = CITIES[form.country] || [];

    return (
        <div>
            <h2 style={{ fontSize: 20, fontWeight: 700, color: '#1e293b', marginBottom: 20 }}>👤 Patient Registration</h2>

            {registered && (
                <div style={{ background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 10, padding: 16, marginBottom: 20 }}>
                    <p style={{ color: '#166534', fontWeight: 700 }}>✅ Patient Registered Successfully!</p>
                    <p style={{ color: '#166534', fontSize: 14, marginTop: 4 }}>MRN: <strong>{registered.mrn}</strong> | Name: {registered.full_name}</p>
                </div>
            )}

            <form onSubmit={handleSubmit}>
                <div style={{ background: 'white', borderRadius: 10, padding: 24, marginBottom: 16, border: '1px solid #e2e8f0' }}>
                    <h3 style={{ fontSize: 14, fontWeight: 700, color: '#1e3a5f', marginBottom: 16, paddingBottom: 8, borderBottom: '2px solid #e2e8f0' }}>Personal Information</h3>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
                        <Field label="Full Name" required>
                            <input style={inputStyle} value={form.full_name} onChange={(e) => set('full_name', e.target.value)} required />
                        </Field>
                        <Field label="Relation / Guardian Name">
                            <div style={{ display: 'flex', gap: 8 }}>
                                <select style={{ ...selectStyle, width: 110, flexShrink: 0 }} value={form.name_relation} onChange={(e) => set('name_relation', e.target.value)}>
                                    {RELATIONS.map(r => <option key={r}>{r}</option>)}
                                </select>
                                <input style={{ ...inputStyle, flex: 1 }} value={form.father_name} onChange={(e) => set('father_name', e.target.value)} placeholder="Guardian name" />
                            </div>
                        </Field>
                        <Field label="Gender" required>
                            <select style={selectStyle} value={form.gender} onChange={(e) => set('gender', e.target.value)} required>
                                <option value="">Select</option>
                                <option>Male</option>
                                <option>Female</option>
                                <option>Other</option>
                            </select>
                        </Field>
                        <Field label="Age / DOB (Years | Months | Exact Date)">
                            <div style={{ display: 'flex', gap: 8 }}>
                                <input type="number" style={{ ...inputStyle, width: 80 }}
                                    value={form.age_years} onChange={(e) => handleAgeYears(e.target.value)}
                                    placeholder="Years" min={0} max={150} />
                                <input type="number" style={{ ...inputStyle, width: 80, background: '#f8fafc' }}
                                    value={form.age_months} onChange={(e) => set('age_months', e.target.value)}
                                    placeholder="Months" min={0} max={11} />
                                <input type="date" style={{ ...inputStyle, flex: 1, background: form.date_of_birth ? '#f0fdf4' : 'white' }}
                                    value={form.date_of_birth} onChange={(e) => handleDOB(e.target.value)}
                                    title="Exact DOB (optional — fills age automatically)" />
                            </div>
                        </Field>
                        <Field label="CNIC / B-Form">
                            <input style={inputStyle} value={form.cnic} onChange={(e) => set('cnic', fmtCNIC(e.target.value))} placeholder="42301-1234567-8 or B-Form No." />
                        </Field>
                        <Field label="Phone" required>
                            <input style={inputStyle} value={form.phone} onChange={(e) => set('phone', fmtPhone(e.target.value))} placeholder="0300-1234567" required />
                        </Field>
                        <Field label="Blood Group">
                            <select style={selectStyle} value={form.blood_group} onChange={(e) => set('blood_group', e.target.value)}>
                                <option value="">Unknown</option>
                                {['A+','A-','B+','B-','O+','O-','AB+','AB-'].map(g => <option key={g}>{g}</option>)}
                            </select>
                        </Field>
                        <Field label="Marital Status">
                            <select style={selectStyle} value={form.marital_status} onChange={(e) => set('marital_status', e.target.value)}>
                                <option value="">Select</option>
                                <option>Single</option><option>Married</option><option>Divorced</option><option>Widowed</option>
                            </select>
                        </Field>
                        <Field label="Religion">
                            <select style={selectStyle} value={form.religion} onChange={(e) => set('religion', e.target.value)}>
                                <option value="">Select</option>
                                <option>Islam</option><option>Christianity</option><option>Hinduism</option><option>Other</option>
                            </select>
                        </Field>
                        <Field label="Nationality">
                            <select style={selectStyle} value={form.nationality} onChange={(e) => set('nationality', e.target.value)}>
                                <option value="">Select</option>
                                {NATIONALITIES.map(n => <option key={n}>{n}</option>)}
                            </select>
                        </Field>
                    </div>
                    <Field label="Address">
                        <textarea style={{ ...inputStyle, height: 60 }} value={form.address} onChange={(e) => set('address', e.target.value)} />
                    </Field>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
                        <Field label="Country">
                            <select style={selectStyle} value={form.country} onChange={(e) => handleCountry(e.target.value)}>
                                {COUNTRIES.map(c => <option key={c}>{c}</option>)}
                            </select>
                        </Field>
                        <Field label="City">
                            <select style={selectStyle} value={form.city} onChange={(e) => set('city', e.target.value)}>
                                <option value="">— Select City —</option>
                                {citiesForCountry.map(c => <option key={c}>{c}</option>)}
                                <option value="Other">Other</option>
                            </select>
                        </Field>
                        <Field label="Occupation">
                            <select style={selectStyle} value={form.occupation} onChange={(e) => set('occupation', e.target.value)}>
                                <option value="">Select</option>
                                {OCCUPATIONS.map(o => <option key={o}>{o}</option>)}
                            </select>
                        </Field>
                    </div>
                </div>

                <div style={{ background: 'white', borderRadius: 10, padding: 24, marginBottom: 16, border: '1px solid #e2e8f0' }}>
                    <h3 style={{ fontSize: 14, fontWeight: 700, color: '#1e3a5f', marginBottom: 16, paddingBottom: 8, borderBottom: '2px solid #e2e8f0' }}>Emergency Contact</h3>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
                        <Field label="Contact Name">
                            <input style={inputStyle} value={form.emergency_contact_name} onChange={(e) => set('emergency_contact_name', e.target.value)} />
                        </Field>
                        <Field label="Contact Phone">
                            <input style={inputStyle} value={form.emergency_contact_phone} onChange={(e) => set('emergency_contact_phone', fmtPhone(e.target.value))} />
                        </Field>
                        <Field label="Contact CNIC">
                            <input style={inputStyle} value={form.emergency_contact_cnic} onChange={(e) => set('emergency_contact_cnic', fmtCNIC(e.target.value))} placeholder="42301-1234567-8" />
                        </Field>
                        <Field label="Relation">
                            <select style={selectStyle} value={form.emergency_contact_relation} onChange={(e) => set('emergency_contact_relation', e.target.value)}>
                                <option value="">Select</option>
                                <option>Father</option><option>Mother</option><option>Spouse</option><option>Son</option><option>Daughter</option><option>Brother</option><option>Sister</option><option>Other</option>
                            </select>
                        </Field>
                    </div>
                </div>

                <div style={{ background: 'white', borderRadius: 10, padding: 24, marginBottom: 16, border: '1px solid #e2e8f0' }}>
                    <h3 style={{ fontSize: 14, fontWeight: 700, color: '#1e3a5f', marginBottom: 16, paddingBottom: 8, borderBottom: '2px solid #e2e8f0' }}>Medical History</h3>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                        <Field label="Known Allergies">
                            <textarea style={{ ...inputStyle, height: 80 }} value={form.allergies} onChange={(e) => set('allergies', e.target.value)} placeholder="e.g. Penicillin, Aspirin..." />
                        </Field>
                        <Field label="Chronic Conditions">
                            <textarea style={{ ...inputStyle, height: 80 }} value={form.chronic_conditions} onChange={(e) => set('chronic_conditions', e.target.value)} placeholder="e.g. Diabetes, Hypertension..." />
                        </Field>
                    </div>
                </div>

                <div style={{ background: 'white', borderRadius: 10, padding: 24, marginBottom: 16, border: '1px solid #e2e8f0' }}>
                    <h3 style={{ fontSize: 14, fontWeight: 700, color: '#1e3a5f', marginBottom: 16, paddingBottom: 8, borderBottom: '2px solid #e2e8f0' }}>Remarks</h3>
                    <textarea style={{ ...inputStyle, height: 80, width: '100%' }} value={form.remarks} onChange={(e) => set('remarks', e.target.value)} placeholder="Any additional notes or remarks about the patient..." />
                </div>

                <button
                    type="submit"
                    disabled={loading}
                    style={{ padding: '12px 32px', background: loading ? '#9ca3af' : '#059669', color: 'white', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer' }}
                >
                    {loading ? 'Registering...' : '✅ Register Patient'}
                </button>
            </form>
        </div>
    );
}
